module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'container-fluid': true, 'basic-layout': true, 'autoix-layout': _vm.$route.meta.appType === 'cabinet', 'control-panel-layout': _vm.$route.meta.appType === 'admin', 'developer-layout': _vm.$route.meta.appType === 'developer'
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.message.status) ? _c('Message') : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    staticClass: "global-loader"
  }, [_c('Loader')], 1), _vm._v(" "), (_vm.user !== null && _vm.user.is_superuser && (_vm.user.username === 'ict' || _vm.user.username === 'weian')) ? _c('div', {
    staticClass: "dev-panel-wrap"
  }, [_c('div', {
    staticClass: "open-panel-button"
  }, [_c('div', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.showPanel
    }
  }, [(!_vm.openPanel) ? _c('span', [_vm._v("OpenPanel")]) : _c('span', [_vm._v("ClosePanel")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openPanel),
      expression: "openPanel"
    }],
    staticClass: "dev-panel"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('openDevice')
      }
    }
  }, [_vm._v("重新解鎖")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('resetAndGetLocalSerialNumber')
      }
    }
  }, [_vm._v("重置藥櫃")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'Main'
      }
    }
  }, [_vm._v("User Panel")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'Admin'
      }
    }
  }, [_vm._v("Admin Panel")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'DevPanel'
      }
    }
  }, [_vm._v("Developer Panel")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'UserImport'
      }
    }
  }, [_vm._v("User Batch Import")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'UserGroupSettings'
      }
    }
  }, [_vm._v("User Group Setting")]), _vm._v(" "), (_vm.currentDevice !== null) ? _c('p', [_vm._v("Current Device: " + _vm._s(_vm.currentDevice.id))]) : _vm._e()], 1)])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1fbf6f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1533
// module chunks = 1